<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="p-3 card">
                <div class="col-3">
                    <button class="btn btn-secondary m-2" (click)="CreateCommitteeDecsions(Add)">
                        <app-feather-icons [icon]="'plus'"></app-feather-icons>
                        <b> {{ "AddcommiteResponses" | translate }}</b>
                    </button>
                </div>
                <div class="col-9"></div>
                <table class="table table-striped mt-3">
                    <thead class="thead-dark">
                        <tr>
                            <th>{{ "commiteResponses" | translate }}</th>
                            <th>{{ "Attachments" | translate }}</th>
                            <th>{{ "Delete" | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let res of commiteResponsessArr">
                            <td>{{ res.details }}</td>
                            <td>
                                <a (click)="AddAttachmentModal(AddAttachment,res.committeeDecsionId,!((caseDetials.stageId==100 || caseDetials.stageId==101) && caseDetials &&  (sharedService.hasCasePermission('P003',caseDetials.caseTypeId) )) );"><i class="fa fa-files-o"></i></a>
                              </td>
                              <td>
                                <a 
                                   (click)="deleteCommite(confirmDelete,res.committeeDecsionId)">
                                    <i class="fa fa-trash"></i>
                                </a>
                              </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>
</div>

<ng-template #Add let-modal>
    <div class="modal-header" style="justify-content: space-between">
        <h4 class="modal-title" id="modal-basic-title">
            {{ "AddcommiteResponses" | translate }}
        </h4>

        <i style="font-size: 20px" class="fa fa-close" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="modal-body">
        <div class="custom-form">
            <div class="col-12 offset-1">
                <div class="card p-3">
                    <div class="form-group row">
                        <div class="col-lg-12">
                            <div class="divformlabel">
                                <label>{{ "commiteResponses" | translate }}</label>
                            </div>
                            <textarea rows="5" class="form-control input-txt-bx" type="text" name="message-to-send"
                                placeholder="{{'commiteResponses' | translate}}" [(ngModel)]="commiteRes"
                                #commiteResponses="ngModel" required></textarea>
                        </div>
                    </div>
                    <div class="row m-2 col-12">
                        <div class="col-4"></div>
                        <div class="col-4">
                            <button *ngIf="isInsert" type="button" class="btn btn-primary" (click)="OnCreateCommitteeDecsions()">
                                {{ "Save" | translate }}
                            </button>
  
                        </div>
                    </div>
                    <h4 class="mt-3" *ngIf="commiteDecsionId">{{ "Attachments" | translate }}</h4>
                    <hr>
                    <app-general-attachment [ElementTypeId]="'13'" [loadDataFP]="loadfromparent" *ngIf="commiteDecsionId!=null"></app-general-attachment>
  
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer row"
    style="justify-content: flex-end; padding: 1rem 2rem">
   <button type="button" class="btn btn-danger col-lg-2" (click)="modal.dismiss('Cross click')">
       {{ "Close" | translate }}
   </button>
</div>
</ng-template>


<ng-template #AddAttachment let-modal>
    <div class="modal-header" style="justify-content: center">
        <h4 class="modal-title" id="modal-basic-title">
            {{'Attachments'|translate}}
        </h4>
    </div>
    <div class="modal-body text-center">
        <app-general-attachment [ElementTypeId]="'13'" [loadDataFP]="loadfromparent"></app-general-attachment>
  
    </div>
    <div class="modal-footer">
  
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "Close" | translate }}
        </button>
    </div>
  </ng-template>
  <ng-template #confirmDelete let-modal>
    <div class="modal-header" style="justify-content: center">
        <h5 class="modal-title text-danger" id="modal-basic-title">
            <b>
                <app-feather-icons [icon]="'alert-triangle'" style="position:relative; top:4px;"></app-feather-icons> {{
                "ConfirmDeleteOperation" | translate
                }}
            </b>
        </h5>
    </div>
    <div class="modal-body text-center">
        <p class="alert fs-6">{{ "SelectedRecordwillbeDeleted" | translate }}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="onDelete(modal)">
            {{ "Yes" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="modal.dismiss('Cross click')">
            {{ "No" | translate }}
        </button>
    </div>
  </ng-template>
  